import styled from 'styled-components';

import { CheckboxCheckedIcon, CheckboxDefaultIcon } from 'static';

export const StyledHeader = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: ${({ theme }) => theme.color.blackSqueeze};
  border-bottom: 1px solid ${({ theme }) => theme.color.porcelain};
`;

export const StyledSelectAllButton = styled.button`
  width: 14px;
  height: 14px;
  border: none;
  outline: none;
  background-image: ${({ checked }) =>
    `url(${checked ? CheckboxCheckedIcon : CheckboxDefaultIcon})`};
  cursor: pointer;
`;

export const StyledHeaderLabel = styled.span`
  margin-left: 11px;
  font-size: 12px;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledListItem = styled.label`
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 61px;
  border-bottom: 1px solid ${({ theme }) => theme.color.porcelain};
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.color.alabaster};
  }

  .checkbox-wrapper {
    padding-right: 20px;
  }

  .item-content {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
  }

  .profile-wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;
    padding-right: 15px;
    flex: 1;
    min-width: 0;
  }

  .email-wrapper {
    font-size: 13px;
    color: ${({ theme }) => theme.color.baliHai};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
    flex-shrink: 0;
    max-width: 220px;
    margin-left: 16px;
  }

  .title-wrapper {
    font-size: 15px;
    font-weight: 500;
  }
`;
